import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "section-padding" }

import TeoPathNavBar from "@/components/TeoPathNavBar.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'ServicesView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TeoPathNavBar, { scrolledPastCarousel: true }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('sectionServices.servicesTitle')), 1),
      _createElementVNode("h4", null, _toDisplayString(_ctx.$t('sectionServices.servicesDescription')), 1),
      _createElementVNode("h5", null, _toDisplayString(_ctx.$t('sectionServices.service1Title')), 1),
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, _toDisplayString(_ctx.$t('sectionServices.service1Description1')), 1),
        _createElementVNode("li", null, _toDisplayString(_ctx.$t('sectionServices.service1Description2')), 1)
      ]),
      _createElementVNode("h5", null, _toDisplayString(_ctx.$t('sectionServices.service2Title')), 1),
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, _toDisplayString(_ctx.$t('sectionServices.service2Description1')), 1),
        _createElementVNode("li", null, _toDisplayString(_ctx.$t('sectionServices.service2Description2')), 1),
        _createElementVNode("li", null, _toDisplayString(_ctx.$t('sectionServices.service2Description3')), 1)
      ]),
      _createElementVNode("h5", null, _toDisplayString(_ctx.$t('sectionServices.service3Title')), 1),
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, _toDisplayString(_ctx.$t('sectionServices.service3Description1')), 1),
        _createElementVNode("li", null, _toDisplayString(_ctx.$t('sectionServices.service3Description2')), 1),
        _createElementVNode("li", null, _toDisplayString(_ctx.$t('sectionServices.service3Description3')), 1)
      ]),
      _createElementVNode("h5", null, _toDisplayString(_ctx.$t('sectionServices.service4Title')), 1),
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, _toDisplayString(_ctx.$t('sectionServices.service4Description1')), 1),
        _createElementVNode("li", null, _toDisplayString(_ctx.$t('sectionServices.service4Description2')), 1),
        _createElementVNode("li", null, _toDisplayString(_ctx.$t('sectionServices.service4Description3')), 1)
      ]),
      _createElementVNode("h5", null, _toDisplayString(_ctx.$t('sectionServices.service5title')), 1),
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, _toDisplayString(_ctx.$t('sectionServices.service5Description1')), 1),
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, _toDisplayString(_ctx.$t('sectionServices.service5Description11')), 1),
          _createElementVNode("li", null, _toDisplayString(_ctx.$t('sectionServices.service5Description22')), 1)
        ]),
        _createElementVNode("li", null, _toDisplayString(_ctx.$t('sectionServices.service5Description2')), 1),
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, _toDisplayString(_ctx.$t('sectionServices.service5Description21')), 1),
          _createElementVNode("li", null, _toDisplayString(_ctx.$t('sectionServices.service5Description22')), 1)
        ]),
        _createElementVNode("h5", null, _toDisplayString(_ctx.$t('sectionServices.service5Description3')), 1),
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, _toDisplayString(_ctx.$t('sectionServices.service5Description31')), 1),
          _createElementVNode("li", null, _toDisplayString(_ctx.$t('sectionServices.service5Description42')), 1)
        ])
      ])
    ])
  ], 64))
}
}

})